(function () {
  'use strict';

  function parallax(el) {
    var bg = el.querySelector('[data-kpm-sb-bg] img');
    if (!bg) return;
    function update() {
      var rect = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (rect.bottom < 0 || rect.top > vh) return;
      var progress = (vh - rect.top) / (vh + rect.height);
      var offset = (progress - 0.5) * 60;
      bg.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0) scale(1.08)';
    }
    update();
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });
  }

  function init() {
    var bands = document.querySelectorAll('[data-kpm-sb]');
    if (!bands.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); }
        });
      }, { threshold: 0.15 });
      bands.forEach(function (b) { io.observe(b); });
    } else {
      bands.forEach(function (b) { b.classList.add('is-revealed'); });
    }

    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    bands.forEach(function (b) {
      if (b.getAttribute('data-parallax') === 'true' && !isMobile) parallax(b);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
